// extracted by mini-css-extract-plugin
var _1 = "FX6aW";
var _2 = "f1dat";
export { _1 as "header", _2 as "results" }
